import type {ItemLayouts} from '@wix/document-services-types'
import {isEmpty} from 'lodash'
import type {CalculateParams} from '../types'
import {convertXToPx} from '../converters/x'
import {isPage, isSection} from '../utils'

export const calculateX = (calculateParams: CalculateParams): void => {
    const {measurementsMapAPI, extensionAPI, compRef, layoutData} = calculateParams
    const {get, set} = measurementsMapAPI
    if (get.x(compRef) !== undefined) {
        return
    }

    if (isSection(extensionAPI, compRef) || isPage(extensionAPI, compRef)) {
        set.x(compRef, 0)
        return
    }

    const itemLayout = layoutData.itemLayout as ItemLayouts
    if (!itemLayout || isEmpty(itemLayout)) {
        set.x(compRef, 0)
        return
    }

    let x = 0

    switch (itemLayout.type) {
        case 'GridItemLayout':
        case 'FixedItemLayout': {
            x = convertXToPx.justifySelf({...calculateParams, value: itemLayout})
            break
        }
        case 'FlexItemLayout':
        case 'OrganizerItemLayout':
        case 'StackItemLayout':
        default: {
            x = 0
            break
        }
    }

    set.x(compRef, x)
}
